import React, { ChangeEvent, useCallback, useState } from 'react'
import "./ModalResumeScheduleNotification.css"
import { DeviceNotification, FrecuencyNotification, FrecuencyNotificationId, ScheduleFrecuency, SubjectNotification, TopicNotification } from '../../CreateScheduleNotificationForm/CreateScheduleNotificationForm'
import moment, { Moment } from 'moment'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import ConfirmButton from '../../../../UIcomponents/Modals/ConfirmButton/ConfirmButton'
import { useTranslation } from 'react-i18next'
import { DayOfWeek, Schedule } from '../../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import LoadingSpinner from '../../../../LoadingSpinner'
import { createScheduleNotification } from '../../../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import InputList from '../../../../UIcomponents/InputList/InputList'
import ItemListNotification from '../../CreateScheduleNotificationForm/ItemListNotification/ItemListNotification'
import TextOptionModalResume from './TextOptionModalResume/TextOptionModalResume'
import useGetScheduleText from '../../../../hooks/useGetScheduleText/useGetScheduleText'

type WeekDayNotification = {
    id:     DayOfWeek
    text:   string
}

type ModalResumeScheduleNotificationProps = {
    frecuency: FrecuencyNotification
    subject: SubjectNotification
    topic: TopicNotification
    device: DeviceNotification
    schedule: ScheduleFrecuency
    title: string
    bodyNotif: string
    onSubmit: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    onCloseModal: () => void
}

const ModalResumeScheduleNotification = ({
    frecuency,
    subject,
    topic,
    device,
    schedule,
    title,
    bodyNotif,
    onSubmit,
    onCloseModal,
}: ModalResumeScheduleNotificationProps) => {

    const { t } = useTranslation()

    const { textDate: resumeDate } = useGetScheduleText({ type: "ScheduleFrecuency", schedule: schedule, frecuencyId: frecuency.id })



    console.log("schedule", schedule)
    return (
        <div className="modal-schedule-notif-resume flex flex-d-column">
           <div className="flex flex-jc-sb">
                <p className="fs-18 fw-600">
                    {t("Notifications:schedule:index:label_16")}
                </p>

                <div className="flex flex-1 flex-jc-end">

                    <TextOptionModalResume 
                        title={t("Notifications:schedule:index:label_01")}
                        text={subject.text}
                    />

                    <TextOptionModalResume 
                        title={t("Notifications:schedule:index:label_07")}
                        text={device.text}
                    />

                    <TextOptionModalResume 
                        title={t("Notifications:schedule:index:label_08")}
                        text={topic.text}
                    />

                    <TextOptionModalResume 
                        title={t("Notifications:schedule:index:label_09")}
                        text={frecuency.text}
                    />

                </div>
           </div>

           <div className="flex-1 flex flex-d-column flex-jc-c mb-20">
                <div className="">
                    <p className="fs-12 fw-600">
                        {title}
                    </p>
                    <p className="fs-12 mt-14">
                        {bodyNotif}
                    </p>

                    <div className="flex mt-20">
                        <div className="">
                            <p className="fs-12 fw-700">
                                {t("Notifications:schedule:index:label_17")}
                            </p>
                            <p className="fs-12 mt-10">
                                {resumeDate}
                            </p>
                        </div>

                        <div className="ml-20">
                            <p className="fs-12 fw-700">
                                {t("Notifications:schedule:index:label_18")}
                            </p>
                            <p className="fs-12 mt-10">{`${moment(schedule.utcHour).format("HH:mm A")}`}</p>
                        </div>
                    </div>
                </div>
           </div>

            <form onSubmit={onSubmit} className="flex flex-d-column flex-jc-end">

                <div className="flex flex-jc-sb">
                    <button
                        onClick={onCloseModal}
                        className="cancel-btn-resume-notif"
                    >
                        {t("Notifications:schedule:index:label_19")}
                    </button>
                    <ConfirmButton text={t("General:label_131")} width="18rem" />
                </div>

            </form>
            
        </div>
    )
}

export default React.memo( ModalResumeScheduleNotification )